import { HarborClient, type IApiClient } from "@pharaday/api";
import { type AxiosInstance } from "axios";
import { injectable } from "inversify";

import { OrganizationProfileRepository } from "../../application/store/organization-profile.repository";
import { AuthenticatedContainer } from "../../authenticated.container";
import type { OrganizationProfile } from "../../domain/entities/organization-profile";
import type { OrganizationProfileDto } from "../dto/organization-profile.dto";

@injectable()
export class RestOrganizationProfileRepository extends OrganizationProfileRepository {
  public readonly axios: AxiosInstance;

  constructor() {
    super();
    this.axios = AuthenticatedContainer.get<IApiClient>(HarborClient).getInstance();
  }

  async getOrganizationProfile(): Promise<OrganizationProfile> {
    const { data } = await this.axios.get<OrganizationProfileDto>(`/organization/profile`);
    return data;
  }
}
